module.exports = __webpack_public_path__ + "img/em_mockup_01.5300e4ac.png";